import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import './Auth.css';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMensaje('');

    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    setCargando(true);

    try {
      await authAPI.resetPassword({ password });
      setMensaje('¡Contraseña actualizada exitosamente! Redirigiendo al inicio de sesión...');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      setError('El enlace ha expirado o es inválido. Solicita uno nuevo.');
      console.error('Error al restablecer contraseña:', error);
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo-rv-azul.png" alt="RV Logo" />
        </div>
        <h1 className="auth-title">Nueva contraseña</h1>
        
        <p className="auth-subtitle">
          Ingresa tu nueva contraseña
        </p>

        {error && <div className="auth-error">{error}</div>}
        {mensaje && <div className="auth-success">{mensaje}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <input
            type="password"
            placeholder="Nueva contraseña*"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="auth-input"
            minLength={6}
          />

          <input
            type="password"
            placeholder="Confirmar contraseña*"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className="auth-input"
            minLength={6}
          />

          <button type="submit" className="auth-button" disabled={cargando}>
            {cargando ? 'Guardando...' : 'Guardar contraseña'}
          </button>
        </form>

        <div className="auth-back-link">
          <Link to="/login" className="auth-link">← Volver al inicio de sesión</Link>
        </div>
      </div>

      <button className="auth-book-btn" onClick={() => { window.location.href = 'https://rodrigovillanuevallanos.com/libro'; }}>
        Más del libro aquí
      </button>
    </div>
  );
};

export default ResetPassword;

